<template>
    <div class="col-md-6">
        <div class="shop_item shop_item-common shop_item-common-service">
            <div v-if="item.badge !== undefined"
                 class="shop_item-common_badge shop_item-badge"
                 :class="'badge-'+this.item.badge.color"
            >
                {{this.item.badge.text}}
            </div>
            <div class="shop_item-common_header">
                <div class="shop_item-common_title">
                    {{this.item.name}}
                </div>
            </div>
            <div class="shop_item-common_params">
                <ul>
                    <li> {{this.visits}}</li>
                </ul>
            </div>
            <div class="shop_item-common_price">
                <currency-symbol :price="item.price"/>

                <div class="shop_item-common_price-label" v-if="isCredit">
                    Доступно в рассрочку
                </div>
            </div>
            <div class="shop_item-common_btn btn btn-square"
                 @click="openService(this.item.id)"
            >
                Купить
            </div>
        </div>
    </div>
</template>

<script>

    import {plural} from "../../utilities";
    import api from "../../api";
    import CurrencySymbol from "../CurrencySymbol";

    export default {
        name: "ShopServiceItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },
        computed: {
            visits() {
                return plural(this.item.visits_limit, ['посещение', 'посещения', 'посещений'])
            },
            isCredit() {
                return this.item.credit.enable !== undefined ? this.item.credit.enable : false
            },
        },
        methods: {
            async openService(itemId) {
                this.$store.commit('SHOW_MODAL_PRELOADER')
                let item = (await api.shop.getCatalogService(itemId)).data;
                this.$store.commit('SET_SHOP_ITEM_SERVICE_MODAL', item)
                this.$store.commit('HIDE_MODAL_PRELOADER')
            },
        },

    }
</script>